module.exports = __webpack_public_path__ + "static/media/advantage.e29dcdad.jpg";